import { render, staticRenderFns } from "./ActivityResources.vue?vue&type=template&id=4b20a86c&scoped=true&"
import script from "./ActivityResources.vue?vue&type=script&lang=js&"
export * from "./ActivityResources.vue?vue&type=script&lang=js&"
import style0 from "./ActivityResources.vue?vue&type=style&index=0&id=4b20a86c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20a86c",
  null
  
)

export default component.exports